import React, { Suspense } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import Constants from '../../submodules/logictry_config/constants';
import UserAccount from '../../services/UserAccount';
import Connect from '../../services/Connect';
import Navigation from '../../services/Navigation';
import WindowSize from '../../services/WindowSize';
import Company from '../../services/Company';
import { reportError } from '../../services/Errors';
import AppRoot from '../../services/AppRoot';
import VerticalCenterContent from '../../styledhtml/VerticalCenterContent';
import FixedFullscreenDiv from '../../components/FixedFullscreenDiv';
import LoadingFullscreen from '../../components/LoadingFullscreen/index';
import LegalPopup from '../../components/LegalPopup/index';
import PoweredByLogictry from '../../components/PoweredByLogictry';
import LogicBaseHeader from '../../components/LogicBaseHeader';
import Server from '../../services/server';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import AuthPopup from '../../components/AuthPopup';
import Status from '../../components/Header/Status';
import { CreateContentPopup } from '../../containers/TreePage/CreateTemplatePopup';
import LogicBaseMessenger from '../../components/LogicBaseMessenger';
import LogicBaseNotificationPopup from '../../components/LogicBaseNotificationPopup';
import LogicBaseNotificationPopupService from '../../services/LogicBaseNotificationPopup';
import LogicBaseMobileDock from '../../components/LogicBaseMobileDock';
import Messenger from '../../services/Messenger';
import { STUDIO_CANVAS_GRADIENT } from '../../styledhtml/StudioContentLayout';
import { LOGIC_BASE_CANVAS_GRADIENT, LOGIC_BASE_HEADER_SCRIM } from '../../styledhtml/LogicBaseContentLayout';

const LogicBaseRoutes = React.lazy(() => import('./logicbaseroutes'));
const StudioRoutes = React.lazy(() => import('./routes'));
const PopoutRoutes = React.lazy(() => import('./popoutroutes'));

const AppWrapper = styled(FixedFullscreenDiv)`
  margin: 0 auto;
  flex-direction: row;
  display: flex;
`;
const StudioCanvas = styled(AppWrapper)`
  background: ${STUDIO_CANVAS_GRADIENT};
`;
const AppContent = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
`;
const PopoutWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;
`;
const FullscreenWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
`;
const LogicBaseMobileCanvasStyles = createGlobalStyle`
  ${Constants.MediaMobile} {
    html,
    body,
    #root {
      background: ${LOGIC_BASE_CANVAS_GRADIENT};
      background-attachment: fixed;
    }
  }
`;

const LogicBaseHeaderShell = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  height: 4rem;

  ${Constants.MediaMobile} {
    display: flex;
    align-items: center;
    height: auto;
    min-height: ${Constants.MobileHeaderHeight};
    padding-top: 0;
    box-sizing: border-box;
    background: ${LOGIC_BASE_HEADER_SCRIM};
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }
`;

const LogicBaseRoutesHost = styled.div`
  ${Constants.MediaMobile} {
    position: relative;
    min-height: calc(100dvh - ${Constants.MobileHeaderHeight});
    min-height: calc(100svh - ${Constants.MobileHeaderHeight});
  }
`;

const LogicBaseWrapper = styled.div`
  background: ${LOGIC_BASE_CANVAS_GRADIENT};

  ${Constants.MediaMobile} {
    position: relative;
    min-height: 100dvh;
    min-height: 100svh;
  }

  ${Constants.MediaTabletAndDesktop} {
    position: fixed;
    inset: 0;
    overflow: hidden;
  }
`;

class App extends LogictryComponent {
  state = {
    hasError: false,
    clearingCompany: false,
  };
  constructor(props) {
    super(props);
    UserAccount.getAccountStatus();
    document.addEventListener('mousedown', (e) => {
      Navigation.__openNewTab = e.altKey || e.metaKey;
      const element = e.target || e.srcElement;
      __recursivelyAddOnclickToAllHrefs(element);
    }, true);
  }
  componentDidMount() {
    const { isWidget } = Constants;
    UserAccount.onStateUpdate(this);
    AppRoot.onStateUpdate(this);
    WindowSize.onStateUpdate(this);
    Connect.onStateUpdate(this);
    Company.onStateUpdate(this);
    Messenger.onStateUpdate(this);
    if (isWidget) Connect.incrementApiKeyCall();
  }
  componentWillUnmount() {
    UserAccount.offStateUpdate(this);
    AppRoot.offStateUpdate(this);
    WindowSize.offStateUpdate(this);
    Connect.offStateUpdate(this);
    Company.offStateUpdate(this);
    Messenger.offStateUpdate(this);
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    const componentDidCatchError = new Error(`ComponentDidCatch: ${error?.message || error || ''}

ComponentStack: ${info?.componentStack || ''}`);
    const stack = error?.stack || componentDidCatchError.stack || '';
    reportError(componentDidCatchError.message, stack, true);
  }
  async clearCompany() {
    if (this.state.clearingCompany) return;
    this.state.clearingCompany = true;
    await Server.clearAccount();
    window.location.reload();
  }
  render() {
    const { mobile } = WindowSize;
    const { hasError } = this.state;
    if (hasError) return <LoadingFullscreen />;
    const { isWidget, isWidgetOnSameDomain } = Constants;
    if (isWidget) {
      const { loadSuccess } = Connect;
      if (loadSuccess === false) return <FullscreenWrapper><VerticalCenterContent><h1>Invalid API Key</h1></VerticalCenterContent></FullscreenWrapper>;
      if (!loadSuccess) return <LoadingFullscreen />;
    }
    const { isLoggedIn, isLoggingOut, isCheckingAccountStatus } = UserAccount;
    const { blur, disableScroll } = AppRoot;
    if (mobile) {
      document.body.style.position = 'unset';
      document.body.style.inset = 'unset';
      document.body.style.width = 'unset';
      document.body.style.height = 'unset';
      document.body.style.overflow = disableScroll ? 'hidden' : 'unset';
    } else {
      document.body.style.position = 'fixed';
      document.body.style.inset = '0px';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
    }

    if (isCheckingAccountStatus || isLoggingOut) return <LoadingFullscreen />;
    if (isLoggedIn && Company.isExpected && !Company.company) return <LoadingFullscreen />;
    if (Company.company?.error === 'NotFound') {
      setTimeout(() => { this.clearCompany(); });
      return <LoadingFullscreen />;
    }
    const showpoweredby = isWidget && !isWidgetOnSameDomain;

    const showLogicBase = Constants.isLogicWiki;
    if (showLogicBase) {
      if (isWidget) return (
        <BrowserRouter>
          <div
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          >
            <Suspense fallback={<LoadingFullscreen />}>
              <LogicBaseRoutes />
            </Suspense>
          </div>
          {showpoweredby && <PoweredByLogictry />}
        </BrowserRouter>
      );
      const messengerOpen = Messenger.view === 'messenger' || Messenger.view === 'fullscreen';
      const mobileDockLayout = mobile && isLoggedIn;
      const topBarLayout = !mobile;
      const showMobileDock = mobileDockLayout && !messengerOpen;
      const pathname = Navigation.location?.pathname || window.location.pathname;
      const homeActive = pathname === Navigation.home;

      return (
        <LogicBaseWrapper>
          <LogicBaseMobileCanvasStyles />
          <LogicBaseRoutesHost
            style={mobile ? {
              paddingTop: Constants.MobileHeaderHeight,
              paddingBottom: showMobileDock ? '5.5rem' : undefined,
            } : {
              position: 'absolute',
              top: '4rem',
              left: 0,
              right: 0,
              bottom: 0,
              overflow: 'hidden',
            }}
          >
            <BrowserRouter>
              <Suspense fallback={<LoadingFullscreen />}>
                <LogicBaseRoutes />
              </Suspense>
            </BrowserRouter>
          </LogicBaseRoutesHost>
          <LogicBaseHeaderShell>
            <LogicBaseHeader
              mobileDockLayout={mobileDockLayout}
              topBarLayout={topBarLayout}
              homeActive={homeActive}
              onGoHome={() => {
                if (messengerOpen) Messenger.updateView('button');
                Navigation.push(Navigation.home);
              }}
              onOpenNotifications={() => LogicBaseNotificationPopupService.open()}
            />
          </LogicBaseHeaderShell>
          {showMobileDock && (
            <LogicBaseMobileDock
              onOpenMessages={() => {
                if (!isLoggedIn) UserAccount.showLoginPopup();
                else Messenger.updateView('messenger');
              }}
              messengerBadge={Messenger.unread}
            />
          )}
          {isLoggedIn && <LogicBaseNotificationPopup />}
          {isLoggedIn && <CreateContentPopup />}
          {isLoggedIn && <LogicBaseMessenger />}
          <LegalPopup />
          <AuthPopup />
        </LogicBaseWrapper>
      );
    }

    if (Navigation.currentLocation[1] === 'popout') {
      return (
        <AppWrapper  style={{ display: 'flex', filter: blur ? 'blur(4px)' : null }}>
          <PopoutWrapper>
            <BrowserRouter>
              <Suspense fallback={<LoadingFullscreen />}>
                <PopoutRoutes />
              </Suspense>
            </BrowserRouter>
          </PopoutWrapper>
        </AppWrapper>
      );
    }

    const appWrapperStyle = { display: 'flex', filter: blur ? 'blur(4px)' : null, position: 'fixed', top: '0px', left: '0px', height: '100%', width: '100%' };
    return (
      <StudioCanvas style={appWrapperStyle}>
        <AppContent>
          <BrowserRouter>
            <Suspense fallback={<LoadingFullscreen />}>
              <StudioRoutes />
            </Suspense>
          </BrowserRouter>
          <LegalPopup />
          {showpoweredby && <PoweredByLogictry />}
          <AuthPopup />
          <CreateContentPopup />
          {isLoggedIn && <Status hideStatusUpdates />}
        </AppContent>
      </StudioCanvas>
    );
  }
}

function __recursivelyAddOnclickToAllHrefs(node) {
  if (!node) return;
  if (node.tagName === 'A') {
    const sendRedirect = Constants.isWidget && Navigation.currentSearch.allowredirects !== 'false';
    const navPushPage = Constants.isApp && (node.href.startsWith(window.location.origin) || !node.href.startsWith('http')) && node.target !== '_blank';
    node.onclick = (e) => {
      if (!node.href) return;
      if (e.metaKey || e.altKey) {
        // Use default open in new window
      } else if (navPushPage) {
        e.preventDefault();
        e.stopPropagation();
        Navigation.push(node.href.split(window.location.origin)[1] || '');
      } else if (sendRedirect) {
        e.preventDefault();
        e.stopPropagation();
        Connect.redirect(node.href);
      }
    }
  }
  if (!node.parentNode) return;
  __recursivelyAddOnclickToAllHrefs(node.parentNode);
}

export default App;
